import { useRef } from 'react';

export const useIsFirstRender = () => {
    const isFirstRenderRef = useRef(true);

    return isFirstRenderRef;
};
